<style>
.edi-detail-bill .detail-bill-footer div.detail-bill-info p.total-p {
    margin: .5em 5px;
    font-size: 1em;
}
.bill-all-info-width {
	width: 100%;
}
.bill-all-info .detail-bill-info-list li {
    padding: 10px 1.2em;
}
.edi-detail-bill .detail-bill-list-flex{
	 width: 100%;
}
.edi-detail-bill .detail-bill-list-flex-li {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
}
.edi-detail-bill .detail-bill-sonlists{
		width: 50%;
		float: none;
}
.edi-detail-bill .detail-bill-sonlists div {
	  float:none;
		word-break: break-all;
		margin: 10px 0;
		font-size: .8em;
    color: #656565;
    box-sizing: border-box;
}
.edi-detail-bill .detail-bill-sonlist-font{
	  font-size: 0.9em;
    font-weight: bolder;
}
</style>
<template>
	<div class="edi-detail-bill">
		<!-- <div class="filter">
			<input type="text" placeholder="" class="ui-search-input"/>
		</div> -->
		<navbar title="餐企对账单-明细"></navbar>
		<div v-show="scrollShow" class="common-scroll detail-scroll">
			<p class="detail-bill-status">订单号：{{returnDetailData.bill_no}}
				<span class="nav-btn" @click="openBillInfo()">
					<img src="../assets/nav-btn.png" alt="">
				</span>
				<span v-if="returnDetailData.bill_state == 0" class="state-grey-font">未确认</span>
				<span v-if="returnDetailData.bill_state == 1" class="state-red-font">已确认</span>
			</p>
			<div class="bill-all-info bill-all-info-width">
				<ul class="detail-bill-info-list bill-all-info-width">
					<li class="detail-bill-fulllist">付款方集团：{{returnDetailData.pay_name}}</li>
					<li class="detail-bill-fulllist">收款方：{{returnDetailData.receive_name}}</li>
					<li class="detail-bill-fulllist detail-bill-remark">整单备注：{{returnDetailData.remark}}</li>
				</ul>
			</div>
			<div class="detail-bill-wrapper">
				<div class="upload-file-div" v-if="uploadDeliverFlag !== undefined || isZ5">
					<label>附件资料：</label>
					<upload-img
						:uploadImgState="uploadImgState"
						:uploadImgList='uploadImgList'
						:imgListLength='otherdata.number'
            :smallDelIco='smallDelIco'
						:billState='Number(returnDetailData.bill_state)'
						@update:smallDelIco='smallDelIco = $event'
						@attachDelPost='attachDelPost'
						@attachBeforeUpload='attachBeforeUpload'
						@attachClick='attachClick'
					></upload-img>
				</div>
				<ul class="detail-bill-list detail-bill-list-flex">
					<li class="detail-bill-list-flex-li">
						<ul class="detail-bill-sonlists returnBill">
							<div class="detail-bill-sonlist-font">实付金额：{{returnDetails.pay_money}}</div>
							<div>应付金额：{{returnDetails.ap_money}}</div>
							<div>抹零金额：{{returnDetails.wipezero_money}}</div>
						</ul>
						<ul class="detail-bill-sonlists returnBill">
							<div>付款方式：{{returnDetails.payment_type}}</div>
							<div>优惠金额：{{returnDetails.discount_money}}</div>
							<div>&nbsp;</div>
						</ul>
					</li>
				</ul>
			</div>
		</div>
		<div v-show="scrollShow" class="detail-bill-footer">
			<!-- <div class="detail-else-info" v-show="show">
				<div v-if="sumMoney">
					<p>退货金额：{{ sumMoney }}元</p>
				</div>
				<div v-else>
					<p>退货金额：{{sumSubTotalSend | numFixed(numScale)}}元</p>
				</div>
			</div>
			<div class="detail-bill-info">
				<span class="detail-bill-total-btn" @click="infoExchange">合计</span>
			</div> -->
			<div v-if="buttonState && returnDetailData.bill_state != 1" class="detail-bill-return f-right">
				<a @click="agreen('1')">同意</a>
			</div>
			<div v-if="buttonState && returnDetailData.bill_state != 1" class="detail-bill-red f-right">
				<a @click="refuseB">退回</a>
			</div>
		</div>
		<loading v-show="loading"></loading>
		<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
		<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
		<tips v-show="tipsB" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatusB"></tips>
		<item-img ref="itemImgRef"></item-img>
	</div>
</template>

<script>
import Loading from '../components/loading'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import NavBar from '../components/NavBar'
import ItemImg from '../components/ItemImg'
import UploadImg from '../components/Upload'
export default {
	data () {
		return {
			uploadImgState: true,
			buttonState: true,
			sumMoney: '',
			scrollShow: false,
			tips: false,
			tipsB: false,
			btnNum: 2,
			loading: true,
			tipsauto: false,
			tipsFont: '',
			numScale: 2,
			sec: 1500,
			returnDetailData: {},
			returnDetails: {},
			otherdata: {},
			queryData: this.$route.query,
			show: false,
			billInfoShow: false,
			isPesc: false, // 是否显示规格的系统参数
			smallDelIco: false,
			isZ5: false,
			uploadDeliverFlag: false, // 不上传附件不允许发单。undefined: 没有此功能；true: 不上传附件不允许发单；false: 不上传附件允许发单
			uploadImgList: [],
			attachUploadUrl: '/cldEdi/business/bill/uploadEnclosure'
		}
	},
	components: {
		'loading': Loading,
		'tips-auto': TipsAuto,
		'tips': Tips,
		'navbar': NavBar,
		'item-img': ItemImg,
		'upload-img': UploadImg
	},
	created () {
		this.loading = true
		var filterData = {
			bill_id: this.queryData.bill_id
		}
		this.$http.post('/cldEdi/business/arapbill_one', filterData).then((response) => {
			this.loading = false
			this.scrollShow = true
			let result = response.body
			if (!result.result) {
				this.uploadImgState = false
				this.buttonState = false
				this.$fxToast.warning(result.message)
				this.$router.push({path: '/main/home'})
				return false
			} else {
				this.returnDetailData = response.body.data
				this.isPesc = this.returnDetailData.isPesc // 是否显示规格的系统参数
				this.isZ5 = response.body.otherdata == null ? false : response.body.otherdata.isZ5
				this.numScale = (this.returnDetailData.number_scale || this.returnDetailData.number_scale === 0) ? this.returnDetailData.number_scale : 2
				this.returnDetails = response.body.data
				this.sumMoney = this.returnDetailData.sum_money
				this.otherdata = response.body.otherdata
				if (this.returnDetailData.bill_state === 1) {
					this.uploadImgState = false
				} else {
					this.uploadImgState = true
				}
				// 获取附件列表
				if (!this.isZ5 && this.uploadDeliverFlag !== undefined) {
					this.getUploadPost()
				}
			}
		}, (response) => {
			this.loading = false
			this.autoTips('服务请求失败，稍后请重试！')
		})
	},
	methods: {
		// 获取附件列表
		getUploadPost () {
			this.$http.post('/cldEdi/business/bill/showEnclosure', {id: this.queryData.bill_id}).then((response) => {
				var data = response.body
				if (data.result) {
					this.uploadImgList = data.data
				} else {
					this.autoTips(data.message)
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		// 删除或者预览
		// seeOrDel (list) {
		// 	if (this.smallDelIco) {
		// 		this.attachDel(list.id)
		// 	} else {
		// 		this.attachClick(list.path)
		// 	}
		// },
		attachAdd () {
			if (this.uploadImgList.length < this.otherdata.number) {
				this.$refs.attachInput.click()
			} else {
				this.autoTips('最多只能上传三个附件')
			}
		},
		attachDel (imgId) {
			this.btnFont = ['确定', '取消']
			this.tipsFont = '确定要删除附件吗？'
			this.tipsTShow('delAttach' + '+' + imgId)
		},
		attachBeforeUpload (attachFile, attachInput) {
			// 文件大小验证
			// let attachFile = e.target.files[0]
			// let attachFile = this.$refs.attachInput.files[0]
			// if (attachFile.size > 5 * 1024 * 1024) {
			// 	this.autoTips('文件大小不能超过5MB')
			// 	return false
			// }
			this.loading = true
			let uploadData = new window.FormData()
			uploadData.append('file', attachFile)
			uploadData.append('id', this.queryData.bill_id)
			uploadData.append('number', String(this.otherdata.number))
			this.$http.post(this.attachUploadUrl, uploadData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((response) => {
				let data = response.body
				if (!data.result) {
					this.loading = false
					this.autoTips(data.data.cause || '上传附件失败')
				} else {
					if (data.data.success) {
						this.uploadImgList.push(data.data.billFiles)
						this.loading = false
						this.autoTips('上传附件成功')
					} else {
						attachInput.value = ''
						this.loading = false
						this.autoTips(data.data.cause)
					}
				}
			}, (response) => {
				attachInput.value = ''
				this.loading = false
				this.autoTips('请求失败，稍后请重试！')
			})
		},
		attachDelPost (imgId, attachInput) {
			let postData = {
				id: imgId
			}
			this.loading = true
			this.$http.post('/cldEdi/business/bill/deleteEnclosure', postData).then((response) => {
				let data = response.body
				if (!data.result) {
					this.loading = false
					this.autoTips(data.data.message || '删除附件失败')
				} else {
					attachInput.value = ''
					this.loading = false
					this.autoTips('删除附件成功')
					this.smallDelIco = false
					var tempArr = []
					this.uploadImgList.forEach((e) => {
						if (e.id !== imgId) {
							tempArr.push(e)
						}
					})
					this.uploadImgList = tempArr
				}
			}, (response) => {
				this.loading = false
				this.autoTips('请求失败，稍后请重试！')
			})
		},
		/* 点击预览图片 */
		attachClick (url) {
			if (this.getFileType(url) === 'image') {
				this.$refs.itemImgRef.open(url)
			} else {
				this.autoTips('非图片附件不支持查看')
			}
		},
		// 取消删除附件回调事件
		cancelDel (msg) {
			this.smallDelIco = false
		},
		/* 上传附件结束 */
		infoExchange () {
			this.show = !this.show
		},
		tipStatus (msg) {
			this.tips = false
			this.msg = msg
			this.refuseBack()
		},
		tipStatusB (msg) {
			this.tipsB = false
			this.msg = msg
			if (this.msg[1] === true) {
				this.refuse()
				return false
			}
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		agreen (state) {
			this.loading = true
			var updateData = {
				bill_state: state,
				bill_id: this.returnDetailData.id
			}
			this.$http.post('/cldEdi/business/arapbill_update', updateData).then((response) => {
				this.loading = false
				var data = response.body
				if (data.result) {
					this.buttonState = false
					this.uploadImgState = false
					this.returnDetailData.bill_state = state
					this.autoTips('对账单已确认')
				} else {
					this.autoTips('失败')
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		refuse () {
			this.tips = true
			this.tipsFont = '确认退回订单？'
		},
		refuseB () {
			this.tipsB = true
			this.tipsFont = '对账单退回后将不可撤销，是否继续？'
		},
		refuseBack () {
			if (this.msg[1]) {
				this.loading = true
				var updateData = {
					bill_state: '0',
					bill_id: this.returnDetailData.id
				}
				this.$http.post('/cldEdi/business/arapbill_update', updateData).then((response) => {
					this.loading = false
					var self = this
					var data = response.body
					if (data.result) {
						this.buttonState = false
						this.returnDetailData.bill_state = 0
						this.autoTips('对账单已退回')
						setTimeout(function () {
							self.$router.go(-1)
						}, 1500)
					} else {
						this.autoTips('失败')
					}
				}, (response) => {
					this.loading = false
					this.autoTips('服务请求失败，稍后请重试！')
				})
			} else {
				return false
			}
		},
		openBillInfo () {
			this.billInfoShow = !this.billInfoShow
		},
		getFileType (url) {
			const tempUrl = url.replace(/\s*/g, '')
			if (/(\.gif|\.jpeg|\.png|\.jpg|\.bmp)$/i.test(tempUrl)) {
				return 'image'
			} else if (/(\.ppt|\.pptx)$/i.test(tempUrl)) {
				return 'ppt'
			} else if (/(\.docx|\.doc)$/i.test(tempUrl)) {
				return 'word'
			} else if (/(\.xlsx|\.xls)$/i.test(tempUrl)) {
				return 'excel'
			} else if (/(\.mp4|\.ogg|\.webm)$/i.test(tempUrl)) {
				return 'video'
			} else {
				return 'default'
			}
		}
	},
	filters: {
		// edi小数位数处理
		numFixed (val, scale) {
			// if (scale) {
			// 	return val.toFixed(scale)
			// } else {
			return val
			// }
		}
	},
	computed: {
		sumSubTotalSend () {
			let sumSubTotalSend = 0
			if (this.returnDetails) {
				for (let i = 0; i < this.returnDetails.length; i++) {
					sumSubTotalSend += this.returnDetails[i].sub_total_send
				}
			}
			sumSubTotalSend = parseFloat((sumSubTotalSend).toFixed(2))
			return sumSubTotalSend
		}
	}
}
</script>



// WEBPACK FOOTER //
// AccountCheckDetailBill.vue?beb2e018